/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Available
 *
 * 1 = CheckedOut
 *
 * 2 = Booked
 */
export enum LoanCarStatus {
  Available = 0,
  CheckedOut = 1,
  Booked = 2,
}
